import http from '@/services/http';

export default {
  obtenerResumen(tipo_cuenta = null) {
    const params = tipo_cuenta ? { tipo_cuenta } : {};
    return http.get('pagos/cuentas-empresa/resumen', { params });
  },

  obtenerCuentas(filtros = {}) {
    return http.get('pagos/cuentas-empresa', { params: filtros });
  },

  obtenerCuentaPorId(id) {
    return http.get(`pagos/cuentas-empresa/${id}`);
  },

  crearCuenta(datos) {
    return http.post('pagos/cuentas-empresa', datos);
  },

  actualizarCuenta(id, datos) {
    return http.put(`pagos/cuentas-empresa/${id}`, datos);
  },

  eliminarCuenta(id) {
    return http.delete(`pagos/cuentas-empresa/${id}`);
  },

  ajustarMonto(id, datos) {
    return http.put(`pagos/cuentas-empresa/${id}/monto`, datos);
  },

  obtenerHistorialMontos(id) {
    return http.get(`pagos/cuentas-empresa/${id}/historial-montos`);
  },

  obtenerMovimientos(id, filtros = {}) {
    return http.get(`pagos/cuentas-empresa/${id}/movimientos`, { params: filtros });
  },

  // ─── Vinculo N:N cuenta <-> medio de pago ─────────────────────────────────

  listarMediosDeCuenta(id) {
    return http.get(`pagos/cuentas-empresa/${id}/medios`);
  },

  /**
   * Catalogo completo de medios de pago. Vive en el modulo `cobros`, no en `pagos`, y
   * devuelve un ARRAY PELADO (sin el envelope { data: { data } } del resto).
   * El editor de vinculos lo necesita para ofrecer los medios que todavia no estan vinculados.
   */
  obtenerCatalogoMedios() {
    return http.get('cobros/tipos-pago');
  },

  /**
   * Espejo de listarMediosDeCuenta para la pantalla de COBRO: el cajero elige el medio y
   * necesita las cuentas de ESE medio. El backend devuelve solo las ACTIVAS.
   */
  obtenerCuentasDeMedio(id_medio_pago) {
    return http.get(`pagos/medios-pago/${id_medio_pago}/cuentas`);
  },

  /**
   * Destinos posibles (cuenta Y medio) para reimputar un cobro (Trello #350). A diferencia de
   * `obtenerCuentasDeMedio`, no se limita al medio actual del cobro — un cobro cargado con el
   * medio equivocado (ej. Efectivo en vez de Mercado Pago) no tiene ningún destino dentro del
   * mismo medio.
   */
  obtenerDestinosReimputacion(id_pago) {
    return http.get('pagos/cuentas-empresa/destinos-reimputacion', { params: { id_pago } });
  },

  vincularMedio(id, { id_medio_pago, es_default = 0 }) {
    return http.post(`pagos/cuentas-empresa/${id}/medios`, { id_medio_pago, es_default });
  },

  // axios only sends a body on DELETE when it is nested under `data`.
  desvincularMedio(id, id_medio_pago) {
    return http.delete(`pagos/cuentas-empresa/${id}/medios`, { data: { id_medio_pago } });
  },

  marcarCuentaDefault(id_medio_pago, id_cuenta) {
    return http.put(`pagos/medios-pago/${id_medio_pago}/cuenta-default`, { id_cuenta });
  },

  actualizarMueveDinero(id_medio_pago, mueve_dinero) {
    return http.put(`pagos/medios-pago/${id_medio_pago}/mueve-dinero`, { mueve_dinero });
  },

  /**
   * Plazo de acreditacion y comision por par cuenta<->medio (WU6c, `conciliacion-externa`
   * CFG-001). `plazo_acreditacion_dias`/`comision_pct` en `null` limpia el valor cargado
   * (CFG-003) — el backend lo persiste tal cual, nunca lo pisa con 0.
   */
  actualizarParametrosAcreditacionMedio(id_cuenta, id_medio_pago, datos) {
    return http.put(`pagos/cuentas-empresa/${id_cuenta}/medios/${id_medio_pago}`, datos);
  },

  // ─── Corte historico + apertura (S6, T6.9) ────────────────────────────────

  diagnosticoCorte(umbral) {
    const params = umbral !== undefined && umbral !== null ? { umbral } : {};
    return http.get('pagos/cuentas-empresa/corte/diagnostico', { params });
  },

  confirmarCorte({ fecha_corte, saldos_declarados } = {}) {
    const body = { fecha_corte };
    if (saldos_declarados !== undefined) body.saldos_declarados = saldos_declarados;
    return http.post('pagos/cuentas-empresa/corte/confirmar', body);
  },

  // ─── Estado de cuenta (S7, T7.9/T7.11) ─────────────────────────────────────
  // Mismo criterio que ReportesDetalle.vue: page/download van en la query string,
  // los filtros de negocio + limit van en el body.

  obtenerEstadoCuenta({ id_cuenta, fecha_desde, fecha_hasta, page = 1, limit = 50 }) {
    return http.post(`reportes/estado-cuenta?page=${page}`, {
      id_cuenta,
      fecha_desde,
      fecha_hasta,
      limit,
    });
  },

  descargarEstadoCuenta({ id_cuenta, fecha_desde, fecha_hasta }) {
    return http.post('reportes/estado-cuenta?download=true', {
      id_cuenta,
      fecha_desde,
      fecha_hasta,
    });
  },
};
